import React, { useState } from "react";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { auth } from "../../firebase/firebase";
import { signOut } from "firebase/auth";
import { useDispatch } from "react-redux";
import {
  setAlbumsAutorizados,
  setMiAlbum,
  updateFiguritas,
} from "../../actions/figuritasActions";

export default function UserProfileDropdown({ currentUser }) {
  const dispatch = useDispatch();

  function handleSignOut() {
    signOut(auth);
    dispatch(updateFiguritas(null));
    dispatch(setMiAlbum(null));
    dispatch(setAlbumsAutorizados([]));
  }

  return (
    <>
      <div className="user-dropdown">
        <div className="user-dropdown-details">
          <img
            src={currentUser.photoURL}
            className="user-profile-photo"
            alt={currentUser.displayName}
          />
          <strong>{currentUser.displayName}</strong>
          <p>{currentUser.email}</p>
        </div>
        <div className="user-dropdown-options">
          <div className="user-dropdown-options-separator" />
          <button
            id="log-out-option"
            onClick={() => {
              handleSignOut();
            }}
          >
            <FontAwesomeIcon icon={faPowerOff} />
            <span>Cerrar Sesión</span>
          </button>
        </div>
      </div>
    </>
  );
}
